import React from 'react';
import { NavLink } from 'react-router-dom';
import { Menu } from 'antd';

const menuList = [
  {
    title: 'Profile',
    url: '/account'
  },
  {
    title: 'Offers',
    url: '/account'
  },
  {
    title: 'Payment',
    url: '/account'
  },
  {
    title: 'Logout',
    url: '/account'
  }
];
const AccountMenu = (
  <Menu style={{ width: 200 }}>
    {menuList.map((item) => (
      <Menu.Item>
        <NavLink to={item.url}>{item.title}</NavLink>
      </Menu.Item>
    ))}
  </Menu>
);

export default AccountMenu;
